import type { ReactNode } from 'react';

/** 読み込み中・エラー・空の 3 状態を 1 か所に集約する */
export function StateBlock({
  loading,
  error,
  empty,
  emptyMessage = 'この月のデータはまだありません。',
  children,
}: {
  loading: boolean;
  error: { message: string } | null;
  empty?: boolean;
  /** 月と無関係な一覧でも使うので、空のときの文言は差し替えられるようにする */
  emptyMessage?: string;
  children: ReactNode;
}) {
  if (loading) {
    return (
      <p className="border border-line bg-surface-raised px-6 py-10 text-sm text-ink-subtle">
        読み込み中…
      </p>
    );
  }
  if (error) {
    return (
      <p className="border border-line bg-surface-raised px-6 py-10 text-sm text-alert">
        {error.message}
      </p>
    );
  }
  if (empty) {
    return (
      <p className="border border-line bg-surface-raised px-6 py-10 text-sm text-ink-subtle">
        {emptyMessage}
      </p>
    );
  }
  return <>{children}</>;
}
